import React, { useEffect } from "react";

export default function BottomNotification({
  message,
  color,
  setCloseNotification,
}) {
  const defaultColor = "bg-blue-700"; // fallback style
  useEffect(() => {
    const timer = setTimeout(() => {
      setCloseNotification(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, [setCloseNotification]);
  return (
    <div
      className={`fixed bottom-0 uppercase left-0 w-full text-xs font-semibold text-center text-white py-2 z-50 ${
        color || defaultColor
      }`}
    >
      {message}
    </div>
  );
}
